<div [matTooltip]="status() | contractStatusLabel">
  <app-text-icon
    class="bold info"
    [class.dashed]="isComing('DRAFT')"
    text="•"
    [color]="boxColor('DRAFT')"
    *appDisplayableForContractStatus="getDisplayableStatusParam('DRAFT')"
  ></app-text-icon>

  <svg
    class="shrink"
    lucideMinus
    [color]="commitColor('REX_VALIDATING')"
    *appDisplayableForContractStatus="getDisplayableStatusParam('REX_VALIDATING')"
  ></svg>
  <app-text-icon
    text="REX"
    [class.dashed]="isComing('REX_VALIDATED')"
    [color]="boxColor('REX_VALIDATED')"
    *appDisplayableForContractStatus="getDisplayableStatusParam('REX_VALIDATED')"
  ></app-text-icon>

  <svg
    class="shrink"
    lucideMinus
    [color]="commitColor('DA_VALIDATING')"
    *appDisplayableForContractStatus="getDisplayableStatusParam('DA_VALIDATING')"
  ></svg>
  <app-text-icon
    text="DA"
    [class.dashed]="isComing('DA_VALIDATED')"
    [color]="boxColor('DA_VALIDATED')"
    *appDisplayableForContractStatus="getDisplayableStatusParam('DA_VALIDATED')"
  ></app-text-icon>

  <svg
    class="shrink"
    lucideMinus
    [color]="commitColor('DP_VALIDATING')"
    *appDisplayableForContractStatus="getDisplayableStatusParam('DP_VALIDATING')"
  ></svg>
  <app-text-icon
    text="DP"
    [class.dashed]="isComing('DP_VALIDATED')"
    [color]="boxColor('DP_VALIDATED')"
    *appDisplayableForContractStatus="getDisplayableStatusParam('DP_VALIDATED')"
  ></app-text-icon>

  <svg
    class="shrink"
    lucideMinus
    [color]="commitColor('RRH_VALIDATING')"
    *appDisplayableForContractStatus="getDisplayableStatusParam('RRH_VALIDATING')"
  ></svg>
  <app-text-icon
    text="RRH"
    [class.dashed]="isComing('RRH_VALIDATED')"
    [color]="boxColor('RRH_VALIDATED')"
    *appDisplayableForContractStatus="getDisplayableStatusParam('RRH_VALIDATED')"
  ></app-text-icon>

  <svg
    class="shrink"
    lucideMinus
    [color]="commitColor('DRH_VALIDATING')"
    *appDisplayableForContractStatus="getDisplayableStatusParam('DRH_VALIDATING')"
  ></svg>
  <app-text-icon
    text="DRH"
    [class.dashed]="isComing('DRH_VALIDATING')"
    [color]="boxColor('DRH_VALIDATING')"
    *appDisplayableForContractStatus="getDisplayableStatusParam('DRH_VALIDATING')"
  ></app-text-icon>

  <svg
    class="shrink"
    lucideMinus
    [color]="commitColor('SIGNING')"
    *appDisplayableForContractStatus="getDisplayableStatusParam('SIGNING')"
  ></svg>
  <fa-icon
    class="signature"
    [icon]="faSignature"
    [class.dashed]="isComing('SIGNED')"
    [style.color]="boxColor('SIGNING')"
    *appDisplayableForContractStatus="getDisplayableStatusParam('SIGNED')"
  ></fa-icon>
</div>
